/*
 * @Author: dengyongliang
 * @Date: 2021-05-27 16:53:46
 * @LastEditTime: 2021-05-28 15:20:02
 * @LastEditors: dengyongliang
 * @Description: 空
 */
'use strict'
const suffix = process.env.NODE_ENV === 'production' ? '' : '.js'

// 提交品牌监控数据
export const BRAND_SAFE_MONITOR_APPLY = '/brand/safeMonitor/apply' + suffix
// 提交品牌监控联系人信息
export const BRAND_SAFE_MONITOR_FILL = '/brand/safeMonitor/fill' + suffix
// 核心品牌域名列表
export const BRAND_SAFE_MONITOR_CORE_DOMAIN_LIST = '/brand/safeMonitor/coreDomainList' + suffix
// 近似商标清单
export const BRAND_SAFE_MONITOR_SIMILAR_TM_LIST = '/brand/safeMonitor/similarTmList' + suffix
// 异常域名清单
export const BRAND_SAFE_MONITOR_EXCEPT_DOMAIN_LIST = '/brand/safeMonitor/exceptDomainList' + suffix
// 域名检测结果
export const BRAND_SAFE_MONITOR_MONITOR_DOMAIN_LIST = '/brand/safeMonitor/monitorDomainList' + suffix
// 查询品牌安全监控报告
export const BRAND_SAFE_MONITOR_INFO = '/brand/safeMonitor/info' + suffix



// WEBPACK FOOTER //
// ./src/actions/brand.js